import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TwoFactorAuthService } from '../../services/two-factor-auth.service';

@Component({
  selector: 'app-two-factor-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './two-factor-modal.component.html',
  styleUrl: './two-factor-modal.component.css'
})
export class TwoFactorModalComponent {
  @Input() show: boolean = false;
  @Output() verified = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  code: string = '';
  isLoading: boolean = false;
  error: string = '';
  warning: string = '';

  constructor(private twoFactorService: TwoFactorAuthService) {}

  async verify(): Promise<void> {
    if (!this.code || this.code.length < 6) {
      this.error = 'Please enter a valid 6-digit code';
      return;
    }

    this.isLoading = true;
    this.error = '';
    this.warning = '';

    try {
      const result = await this.twoFactorService.verifyLogin(this.code);
      
      if (result.success) {
        if (result.warning) {
          this.warning = result.warning;
          // Show warning briefly then continue
          setTimeout(() => {
            this.verified.emit();
          }, 2000);
        } else {
          this.verified.emit();
        }
      } else {
        this.error = result.message || 'Invalid code. Please try again.';
        this.code = '';
      }
    } catch (err) {
      this.error = 'An error occurred. Please try again.';
    } finally {
      this.isLoading = false;
    }
  }

  onCodeInput(event: any): void {
    // Only allow numbers
    this.code = event.target.value.replace(/[^0-9A-Fa-f]/g, '').substring(0, 8);
    this.error = '';
  }

  cancel(): void {
    this.code = '';
    this.error = '';
    this.cancelled.emit();
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter' && this.code.length >= 6) {
      this.verify();
    }
  }
}














